var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:['emirates-filter-button', {
        'emirates-filter-button_active': _vm.modelValue,
    }],attrs:{"type":"button","data-testid":"emirates-filter-button"},on:{"click":function($event){return _setup.emit('update:modelValue', !_vm.modelValue)}}},[_c(_setup.Typo,{attrs:{"variant":_setup.TypoVariant.BodyMMedium}},[_vm._v("Только туры на")]),_vm._v(" "),_c('span',{staticClass:"emirates-filter-button__logo"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }